//@ts-check
/**
 * @callback requestCallback
 */
import React, { useState, useEffect, Suspense } from 'react';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "../Css/Login.css";
import Login from '../HomePage/Login';
import Head from '../HomePage/Head';
// import Foot from '../HomePage/Foot';
import HomeRoute from './HomeRoute';
import HomeRoutePanel from './HomeRoutePanel';
import FAQ from 'src/Page/FormBasic/FAQ';
import CaseProgressQuery from '../Page/CaseProgressQuery/CaseProgressQuery';
import CaseProgressList from '../Page/CaseProgressQuery/CaseProgressList';

import ProjectChapterRoutePanel from '../Page/IPC/ProjectChapter/ProjectChapterRoutePanel';
import SystemSelector from '../HomePage/SystemSelector';
import EmailLogin from '../HomePage/EmailLogin';

import { MessageBox } from '../Components/Dialogs/MessageBox';
import { GlobalMessageBox, GlobalConfirmBox, globalState, setTheme, getThemeCookie } from './RootMiddleware'

import { ConfirmBox } from '../Components/Dialogs/ConfirmBox';
import Overlay from '../Components/Overlay/Overlay';
import ErrorBoundary from '../Basic/ErrorBoundary';
import { SignInStatusProvider, HeaderFooterContext, FooterContext, FooterProvider, HeaderContext, HeaderProvider, LoginProvider } from '../Basic/BasicData';

/* kendo globalization tool */
import { LocalizationProvider, IntlProvider, load, loadMessages } from '@progress/kendo-react-intl';

/* cldr 語言包 */
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import currencyData from 'cldr-core/supplemental/currencyData.json';
import weekData from 'cldr-core/supplemental/weekData.json';

/* zh語系 語言包 */
import zhNumbers from 'cldr-numbers-full/main/zh-Hant/numbers.json';
import zhLocalCurrency from 'cldr-numbers-full/main/zh-Hant/currencies.json';
import zhCaGregorian from 'cldr-dates-full/main/zh-Hant/ca-gregorian.json';
import zhDateFields from 'cldr-dates-full/main/zh-Hant/dateFields.json';
import zhTimeZoneNames from 'cldr-dates-full/main/zh-Hant/timeZoneNames.json';

// kendo DOM 多國語言
import messages from '../i18n/kendoMessages';
// 多國語系i18N
import '../i18n/i18n.js';
import { useTranslation } from 'react-i18next';
import { Button } from '@progress/kendo-react-buttons';
import SSOLogin from '../HomePage/SSOLogin';
import ResetCountDown from '../HomePage/ResetCountDown';
import { ChapterPageIndexProvider } from '../Page/IPC/ProjectChapter/ChapterPageIndexProvider';
import UserGuide from '../HomePage/UserGuide';



/**
 * Root元件
 *
 * @component
 * @example
 */
const RootRoute = (props) => {

    const { headerFooterStatus, setHeaderFooterStatus } = React.useContext(HeaderFooterContext);
    const { headerStatus, setHeaderStatus } = React.useContext(HeaderContext);
    const [loading, setLoading] = useState(false);
    const { i18n } = useTranslation();
    const [i18nLanguage, seti18nLanguage] = useState(localStorage.getItem('i18nextLng') || "zh-TW"); // 從localStorage抓現在的語言
    const [lang, setLang] = useState("zh-Hant");
    const [visible, setVisible] = useState(true);


    // 載入基本語言包
    // useEffect(() => {
    //載入必要的語言包 (預設已有en-US)
    load(
        likelySubtags,
        currencyData,
        weekData,
        zhLocalCurrency,
        zhNumbers,
        zhCaGregorian,
        zhDateFields,
        zhTimeZoneNames
    );
    //載入kendo元件語言包
    loadMessages(messages.zh, 'zh-Hant');
    // }, [])

    // 切換語系
    useEffect(() => {
        const loadCache = async () => {
            i18n.changeLanguage(i18nLanguage);
            setLang(i18nLanguage === 'zh-TW' ? 'zh-Hant' : i18nLanguage);
        }
        if (getThemeCookie() != null) {
            setTheme(getThemeCookie());
        } else {
            setTheme('blue');
        }

        loadCache();
    }, [i18nLanguage]);

    useEffect(() => {
        let href = window.location.href;
        setHeaderFooterStatus(href.includes("ProjectChapter"));
        setHeaderStatus(false);
        setLoading(true);
    }, [])

    const openMenu = () => {
        setVisible(!visible);
    }

    return (
        <LocalizationProvider language={lang}>
            <IntlProvider locale={lang}>
                <SignInStatusProvider>
                    <ChapterPageIndexProvider>
                        <FooterProvider>
                            <HeaderProvider>
                                <LoginProvider>
                                    <div className="blue_bg">
                                        <ConfirmBox />
                                        <MessageBox />
                                        <GlobalMessageBox stateConfig={globalState.globalMessageBoxSettings} />
                                        <GlobalConfirmBox stateConfig={globalState.globalConfirmBoxSettings} />
                                        <Overlay />
                                        {/*@ts-ignore*/}
                                        <ErrorBoundary>
                                            {/*@ts-ignore*/}
                                            <BrowserRouter basename={process.env.PUBLIC_URL}>
                                                <Head value={i18nLanguage} setValue={(value) => seti18nLanguage(value)} />
                                                <Switch>
                                                    <Route exact path="/" component={Login} />
                                                    <Route exact path="/ResetCountDown" component={ResetCountDown} />
                                                    <Route exact path="/EmailLogin" component={EmailLogin} />
                                                    <Route exact path="/FAQ" component={FAQ} />
                                                    <Route exact path="/CaseProgress/Query" component={CaseProgressQuery} />

                                                    {/* 確認加載後再決定Menu */}
                                                    {loading &&
                                                        <div id="container" className={headerFooterStatus ? "navOpen full-screen" : "navOpen"}  >
                                                            {/* <    className={visible ? "" : "close-menu"}>
                                                    <div className={visible ? "" : "close-menu"}>
                                                        <Button icon="menu" onClick={openMenu} />
                                                    </div>
                                                    <HomeRoutePanel visible={visible} />
                                                    {
                                                        headerFooterStatus
                                                            ? <ProjectChapterRoutePanel visible={visible} />
                                                            : <HomeRoutePanel visible={visible} />
                                                    }
                                                </nav> */}
                                                            <Suspense fallback={<Overlay />}>
                                                                <Route path="/" render={() => <HomeRoute />} />
                                                            </Suspense>
                                                        </div>
                                                    }
                                                </Switch>
                                            </BrowserRouter>
                                        </ErrorBoundary>
                                        {/* <Foot /> */}
                                    </div>
                                </LoginProvider>
                            </HeaderProvider>
                        </FooterProvider>
                    </ChapterPageIndexProvider>
                </SignInStatusProvider>
            </IntlProvider>
        </LocalizationProvider>
    );
}

export default RootRoute;